import { Injectable, Injector } from '@angular/core';
import { BaseState } from 'src/app/common/base/base.state'; import { Action, Selector, State, StateContext } from '@ngxs/store';
import { WorkPerformerRefresh, WorkPerformerCreate, WorkPerformerUpdate, WorkPerformerDelete, WorkPerformerRefreshByID } from './work-performers.action';
import { WorkPerformer } from 'src/app/services/work-performer/work-performer';
import { WorkPerformerService } from 'src/app/services/work-performer/work-performers.service';

export class WorkPerformerStateModel {
	data: WorkPerformer[] = [];
}

@State<WorkPerformerStateModel>({
	name: 'WorkPerformers',
	defaults: {
		data: [],
	}
})
@Injectable()
export class WorkPerformerState extends BaseState {
	constructor(
		protected override injector: Injector,
		private service: WorkPerformerService

	) {
		super(injector);
	}

	@Selector()
	static read(state: WorkPerformerStateModel) {
		return state.data;
	}

	@Action(WorkPerformerRefresh)
	refresh({ patchState }: StateContext<WorkPerformerStateModel>) {
		this.service.Read().subscribe(data => {
			const WorkPerformers = data as WorkPerformer[];
			patchState({ data: WorkPerformers });
		},
			error => console.error(error)
		);
	}

	@Action(WorkPerformerRefreshByID)
	refreshByID({ getState, patchState }: StateContext<WorkPerformerStateModel>, { id }: WorkPerformerRefreshByID) {
		this.service.ReadOne(id).subscribe(
			data => {
				const WorkPerformer = data as WorkPerformer;
				const state = getState();
				const index = state.data.map(x => x.id).indexOf(id);

				if (index >= 0) {
					state.data.splice(index, 1);
				}
				patchState({
					data: [...state.data, WorkPerformer]
				});
			}
		);
	}

	@Action(WorkPerformerCreate)
	create({ getState, patchState }: StateContext<WorkPerformerStateModel>, { item }: WorkPerformerCreate) {
		patchState({
			data: [...getState().data, item]
		});
	}

	@Action(WorkPerformerUpdate)
	update({ getState, patchState }: StateContext<WorkPerformerStateModel>, { id, item }: WorkPerformerUpdate) {
		const state = getState();
		const index = state.data.map(x => x.id).indexOf(id);

		if (index >= 0) {
			state.data.splice(index, 1);
		}
		patchState({
			data: [...state.data, item]
		});
	}

	@Action(WorkPerformerDelete)
	delete({ getState, patchState }: StateContext<WorkPerformerStateModel>, { id }: WorkPerformerDelete) {
		patchState({
			data: getState().data.filter(x => x.id != id)
		});
	}


}
